import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=5286c280"
import script from "./GameHeader.vue?vue&type=script&lang=js"
export * from "./GameHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports